module.exports = __webpack_public_path__ + "img/upload.32c3747c.svg";